//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
let d=[[[0,"CanOptimizeCurve",1,0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[0,"DistanceThreshold",1,0],[1,"EndAngle",0,"Expression",0],[1,"Face",0,"ScCollector",0],[1,"IntervalAngle",0,"Expression",0],[0,"IsAssociative",1,0],[1,"IsoclineAngle",0,"Expression",0],[0,"IsoclineTypes",1,0],[0,"ReferenceDirection",1,"Direction",0],[1,"StartAngle",0,"Expression",0]],[[[],"CreateIsocline",{},0,0]],[]];
SPLM.Features.IsoclineCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.IsoclineCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.IsoclineCurveBuilder.CurveTypes = Object.freeze({
    "Single" : "Single", "Multiple" : "Multiple"});

export default SPLM;